import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translation.json";
import la from "./locales/la/translation.json";
import kr from "./locales/kr/translation.json";

const savedLng = localStorage.getItem("i18nextLng") || "en";

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      la: { translation: la },
      kr: { translation: kr }
    },
    lng: savedLng, // 기본 언어
    fallbackLng: "en",
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
